import { prefixClassName } from "@smartrr/shared/components/primitives";
import React from "react";

import { useBackgroundImageFromLineItems } from "./hooks";
import { StyledFullWidthProductImage } from "../../../styles";
import { ICardProductImage } from "../../../types";

export const CardProductImageBackground = ({ delivery }: ICardProductImage) => {
  const bgImg = useBackgroundImageFromLineItems(delivery);

  return (
    <div style={{ overflow: "hidden" }} data-testid="product-image-background">
      <StyledFullWidthProductImage className={prefixClassName("image full-width")} src={bgImg}>
        {" "}
      </StyledFullWidthProductImage>
    </div>
  );
};
